import { deleteKv, getKv, setKv } from './offlineDb';

const ACCOUNT_KEY = 'auth:account';

export async function saveCachedAccount(account, sessionUser = null) {
  if (!account) return;
  await setKv(ACCOUNT_KEY, {
    account,
    user: sessionUser
      ? {
        id: sessionUser.id,
        email: sessionUser.email,
      }
      : { id: account.auth_user_id, email: account.email },
    savedAt: Date.now(),
  });
}

export async function getCachedAccount(authUserId) {
  const packed = await getKv(ACCOUNT_KEY);
  if (!packed?.account) return null;
  if (authUserId && packed.account.auth_user_id && packed.account.auth_user_id !== authUserId) {
    if (packed.user?.id && packed.user.id !== authUserId) return null;
  }
  return packed.account;
}

export async function getCachedAuthBundle() {
  return (await getKv(ACCOUNT_KEY)) || null;
}

export async function clearCachedAccount() {
  await deleteKv(ACCOUNT_KEY);
}
